
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/siteCreation/horizontalLoader.scss.css.virtualfile';
        module.exports = {"siteCreationHorizontalLoader":"_siteCreationHorizontalLoader_s7gr5_1"};